import CuentaBancariaPanel from '@/components/settings/cuenta-bancaria/CuentaBancariaPanel';

export default function CuentaBancariaPage() {
  return <CuentaBancariaPanel />;
}
